import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import CatalogTransferTypeBox from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferTypeBox'
import CatalogTransferWizardHeader from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/CatalogTransferWizardHeader'

const TransferTypeStep = () => {
    const { catalogTransferWizardStore, wizardFlowStore } = useContext(StoresContext)

    const handleClick = async (type: 'full' | 'partial') => {
        catalogTransferWizardStore.updateCatalogTransferDTO({ transferType: type })
        await wizardFlowStore.isCurrentStepValid()
        wizardFlowStore.advanceIndex()
    }

    return (
        <div className="ct-transfer-type-step ct-wizard-step-container">
            <CatalogTransferWizardHeader
                title="Catalog Action"
                subtitle="Do you need to complete a full or partial catalog transfer?"
            />
            <div className="catalog-transfer-type-selection">
                <div className="ct-transfer-types">
                    <CatalogTransferTypeBox heading="Full" className="ct-full" onClick={() => handleClick('full')}>
                        <div>
                            <p>I want to acquire the rights to all the works in another Member's catalog.</p>
                        </div>
                    </CatalogTransferTypeBox>
                    <CatalogTransferTypeBox
                        heading="Partial"
                        className="ct-partial"
                        onClick={() => handleClick('partial')}
                    >
                        <div>
                            <p>I only want to acquire the rights to specific works from another Member's catalog.</p>
                        </div>
                    </CatalogTransferTypeBox>
                </div>
            </div>
        </div>
    )
}

export default TransferTypeStep
